import _extends from "@babel/runtime/helpers/extends";
import { useTheme } from "@smartsheet/lodestar-core";
import { CloseIcon as LodestarCloseIcon } from "@smartsheet/lodestar-icons";
import { CloseIcon as UrsaCloseIcon } from "@smartsheet/ursa-icons";
import React, { forwardRef } from "react";
import { ToastDismissButtonStyled } from "../styled/ToastDismissButtonStyled";
export const ToastDismissButton = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    key
  } = useTheme();
  const themeMode = key;
  return /*#__PURE__*/React.createElement(ToastDismissButtonStyled, _extends({
    ref: ref,
    "aria-hidden": true,
    themeMode: themeMode
  }, props), getIcon(themeMode));
});
ToastDismissButton.displayName = "ToastDismissButton";
const getIcon = themeMode => {
  switch (themeMode) {
    case "ursa-light":
    case "ursa-dark":
      return /*#__PURE__*/React.createElement(UrsaCloseIcon, {
        size: 24,
        color: "currentColor"
      });
    default:
      return /*#__PURE__*/React.createElement(LodestarCloseIcon, {
        size: "small"
      });
  }
};
//# sourceMappingURL=ToastDismissButton.js.map